import { PresetContentFilter } from 'constants-content';

export const filtersOnPills = [
  PresetContentFilter.FeatureReservableAvailableDays,
];
